module.exports = __webpack_public_path__ + "img/beginning@2x.6b22a20.jpg";